// extracted by mini-css-extract-plugin
export default {"cell":"style_cell__eb8lE"};